import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n'
import {getCommunityName,getCommunityId} from '@/api/community/communityApi'

Vue.prototype.getCommunityId = function(){
  return getCommunityId()
}
Vue.prototype.getCommunityName = function(){
  return getCommunityName()
}

Vue.prototype.hasPrivilege = function(_privaleges) {
  const privilegesToCheck = Array.isArray(_privaleges) ? _privaleges : [_privaleges];
  let userPrivileges = localStorage.getItem('hc_staff_privilege');
  if (userPrivileges) {
    userPrivileges = userPrivileges.split(',');
  } else {
    return false;
  }
  return privilegesToCheck.some(item => userPrivileges.includes(item));
}
Vue.prototype.toDoc = function(url) {
  window.open('http://www.homecommunity.cn/'+url, '_blank')
}

Vue.prototype.$getUser = function() {
  let user = JSON.parse(localStorage.getItem('user'))
  return user
}

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

// ==================== 自动退出登录逻辑 (2 小时) ====================
const IDLE_TIMEOUT = 2 * 60 * 60 * 1000
let idleTimer = null

function resetIdleTimer() {
  if (idleTimer) clearTimeout(idleTimer)
  idleTimer = setTimeout(() => {
    const user = localStorage.getItem('user')
    if (user) {
      alert('由于您长时间未操作，系统已自动退出登录。')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('hc_staff_privilege')
      window.location.href = '/#/login'
    }
  }, IDLE_TIMEOUT)
}

window.addEventListener('mousemove', resetIdleTimer, false)
window.addEventListener('keydown', resetIdleTimer, false)
window.addEventListener('click', resetIdleTimer, false)
window.addEventListener('scroll', resetIdleTimer, false)

resetIdleTimer()
// =================================================================
